__turbopack_context__.v({
  "className": "caveat_8aac8beb-module__-gryMW__className",
});
